export default "__VITE_ASSET__DS9$TlD2__"